
<form [formGroup]="searchForm" >
    <div>
        <input class="form-control-input with-icon caption" type="text" matInput [formControl]="dataItemSelector"  placeholder="Data field" [matAutocomplete]="dataLabelAuto" required>
        <mat-autocomplete #dataLabelAuto="matAutocomplete" [displayWith]="dataItemListDisplayHelper" (optionSelected)="handleDataItemSelectorChange($event)">
            <mat-option *ngFor="let option of dataLabelListObservable | async" [value]="option">
                {{option.name}}
            </mat-option>
        </mat-autocomplete>
        <input class="form-control-input with-icon caption" type="text" matInput [formControl]="ruleSelector"  placeholder="Rule" [matAutocomplete]="rulesAuto" required>
        <mat-autocomplete #rulesAuto="matAutocomplete" [displayWith]="ruleDisplayFn">
            <mat-option *ngFor="let option of rulesListObservable | async" [value]="option">
                {{ ruleNameDisplayMap?.[option] || option }}
            </mat-option>
        </mat-autocomplete>
        <input class="form-control-input caption" matInput  placeholder="Value" [formControl]="inputValueController">
    </div>
 </form>
 